import { useState, useRef, useEffect } from 'react'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import VideoModal from '@/app/(content)/media/VideoModal'

export default function SmTestimonialCard({
  testimonial,
  index,
  selectedTestimonialIndex,
  toggleTestimonial,
}) {
  const contentRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef(null)
  const [openModals, setOpenModals] = useState({})
  const toggleModal = (index) => {
    setOpenModals((prevOpenModals) => ({
      ...prevOpenModals,
      [index]: !prevOpenModals[index],
    }))
    setIsPlaying(!isPlaying)
  }

  const handleStopPlayClick = () => {
    if (videoRef.current) {
      videoRef.current.pause()
      setIsPlaying(false)
    }
  }
  useEffect(() => {
    const videoElement = videoRef.current

    const handleVideoEnd = () => {
      console.log('Video has ended.')
      setIsPlaying(false)
    }

    if (videoElement) {
      videoElement.addEventListener('ended', handleVideoEnd)
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('ended', handleVideoEnd)
      }
    }
  }, [])

  return (
    <motion.div
      className={clsx(
        'relative flex flex-col justify-end space-y-4 bg-[#F8F9FCBF] bg-cover  rounded-2xl p-5 overflow-hidden',
      )}
      style={{
        background: `url(${testimonial?.src}) no-repeat center center`,
        backgroundSize: 'cover',
      }}
      initial={{ height: selectedTestimonialIndex === index ? 280 : 86 }}
      animate={{
        height: selectedTestimonialIndex === index ? 280 : 86,
      }}
      transition={{ duration: 0.2 }}
    >
      {selectedTestimonialIndex !== index && (
        <div
          className={clsx(
            'flex items-center justify-end space-y-2.5 space-x-2.5',
          )}
        >
          <button
            className={clsx(
              'rounded-full bg-[#FFFFFFCC] flex items-center justify-center p-2 border border-[#AEAEAE]',
            )}
            onClick={() => {
              toggleTestimonial(index)
            }}
          >
            {selectedTestimonialIndex === index ? (
              <ChevronUpIcon className="text-gray-900 w-5 h-5 stroke-[2px]" />
            ) : (
              <ChevronDownIcon className="text-gray-900 w-5 h-5 stroke-[2px]" />
            )}
          </button>
        </div>
      )}

      {selectedTestimonialIndex === index && (
        <div
          ref={contentRef}
          className="absolute z-10 w-full left-0 top-0 h-full rounded-2xl  "
        >
          {!isPlaying && (
            <div
              onClick={() => {
                if (selectedTestimonialIndex !== index) {
                  // toggleTestimonial(index)
                } else {
                  toggleModal(index)
                  setIsPlaying(true)
                }
              }}
              className="absolute inset-0 flex items-center justify-center cursor-pointer "
            >
              <svg
                width="98"
                height="98"
                viewBox="0 0 98 98"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_bi_6187_33305)">
                  <circle
                    cx="49"
                    cy="48.9956"
                    r="48"
                    fill="black"
                    fill-opacity="0.25"
                  />
                  <circle
                    cx="49"
                    cy="48.9956"
                    r="48.5"
                    stroke="url(#paint0_linear_6187_33305)"
                    stroke-opacity="0.2"
                  />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M66.496 51.59C68.4975 50.4355 68.4975 47.547 66.496 46.3926L40.4989 31.3975C38.4989 30.2439 36 31.6873 36 33.9962V63.9863C36 66.2952 38.4989 67.7386 40.4989 66.585L66.496 51.59Z"
                  fill="white"
                />
                <defs>
                  <filter
                    id="filter0_bi_6187_33305"
                    x="-20"
                    y="-20.0044"
                    width="138"
                    height="138"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_6187_33305"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_6187_33305"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feMorphology
                      radius="1.46045"
                      operator="dilate"
                      in="SourceAlpha"
                      result="effect2_innerShadow_6187_33305"
                    />
                    <feOffset dx="-0.730227" dy="0.730227" />
                    <feGaussianBlur stdDeviation="0.365113" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect2_innerShadow_6187_33305"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_6187_33305"
                    x1="85.7742"
                    y1="7.57625"
                    x2="49"
                    y2="96.9956"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          )}
          {!testimonial?.videoUrl?.includes('drive.google.com') &&
            isPlaying && (
              <div
                // className="fade-out absolute inset-0 flex items-center cursor-pointer justify-center"
                className="fade-out absolute inset-0 flex items-center justify-center"
                onClick={handleStopPlayClick}
              >
                <svg
                  width="98"
                  height="98"
                  viewBox="0 0 98 98"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_di)">
                    <circle
                      cx="49"
                      cy="49"
                      r="48"
                      fill="black"
                      fill-opacity="0.25"
                    />
                    <circle
                      cx="49"
                      cy="49"
                      r="48.5"
                      stroke="url(#paint0_linear)"
                      stroke-opacity="0.2"
                    />
                  </g>
                  <rect x="32" y="32" width="14" height="34" fill="white" />
                  <rect x="52" y="32" width="14" height="34" fill="white" />
                  <defs>
                    <filter
                      id="filter0_di"
                      x="-20"
                      y="-20"
                      width="138"
                      height="138"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="10"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feMorphology
                        radius="1.46045"
                        operator="dilate"
                        in="SourceAlpha"
                        result="effect2_innerShadow"
                      />
                      <feOffset dx="-0.730227" dy="0.730227" />
                      <feGaussianBlur stdDeviation="0.365113" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
                      />
                      <feBlend mode="normal" in2="SourceGraphic" />
                    </filter>
                    <linearGradient
                      id="paint0_linear"
                      x1="85.7742"
                      y1="7.58065"
                      x2="49"
                      y2="97"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            )}
        </div>
      )}
      {selectedTestimonialIndex === index && (
        <div
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #0D0E0E 100%)',
          }}
          className=" flex items-center justify-between z-0 absolute bottom-[0px] left-0 right-0  text-white p-4 rounded-b-lg"
        >
          <div>
            <h3 className="text-lg text-animate">{testimonial.title}</h3>
          </div>
        </div>
      )}
      {openModals[index] && testimonial.videoUrl && (
        <VideoModal
          videoUrl={testimonial.videoUrl}
          open={openModals[index]}
          setOpen={() => toggleModal(index)}
        />
      )}
    </motion.div>
  )
}
